import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useLayoutEffect, useRef } from "react";

import MainContainer from "../../../components/container/MainContainer";
import TextContainer from "../../../components/text/TextContainer";
import { getProject, unsetProjects } from "../../../features/projectsSlice";
import PageTitle from "../../../components/titles/PageTitle";
import { openModal } from "../../../features/modalSLice";
import Loading from "../../../components/loading/Loading";
import Modal from "../../../components/modal/Modal";
import ProjectTitle from "../../../components/text/ProjectTitle";
import TextArrayContainer from "../../../components/text/TextArrayContainer";
import BudgetTableContainer from "../../../components/text/BudgetTableContainer";
import PDFComponent from "../../../components/pdf/PDFComponent";
import { formatCurrency } from "../../../util";
import AddCommunityPlanningApproval from "./AddCommunityPlanningApproval";
import AddCommunityPlanningRejection from "./AddCommunityPlanningRejection";
import DisplayComments from "../../../components/text/DisplayComments";
import { useAuthorization } from "../../../hooks/useAuthorization";
import CategoryBudgetTableContainer from "../../../components/text/CategoryBudgetTableContainer";
import ProposalComp from "../../../components/projects/ProposalComp";
import useProposalApplication from "../../../hooks/useProposalApplication";
import { useCallback } from "react";

const CommunityProposalReview = () => {
  const { id } = useParams();
  const pdfRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const project = useSelector((state) => state.projects.selected); // List of ongoing projects
  const modalContent = useSelector((state) => state.modal.content);
  const loading = useSelector((state) => state.projects.load.getProject);
  // const [data, setData] = useState([]);

  const openAddCommunityPlanningApprove = () => {
    dispatch(
      openModal(
        <AddCommunityPlanningApproval
          id={project.id}
          community_id={project.community_id}
          name={project.name}
        />
      )
    );
  };

  const openAddCommunityPlanningReject = () => {
    dispatch(
      openModal(
        <AddCommunityPlanningRejection id={project.id} name={project.name} />
      )
    );
  };

  const openAddCommunityPlanningTotalReject = () => {
    dispatch(
      openModal(
        <AddCommunityPlanningRejection
          reject
          id={project.id}
          name={project.name}
        />
      )
    );
  };

  useLayoutEffect(() => {
    if (id) {
      dispatch(getProject(id));
    }
    return () => {
      dispatch(unsetProjects());
    };
  }, []);

  useLayoutEffect(() => {
    if (
      (project.id && project?.stage?.step_number < 9) ||
      (project.id && project?.stage?.step_number > 9)
    ) {
      return navigate("/requests/community-approvals", { replace: true });
    }
  }, [project, navigate]);

  //Construct Data for PDF proposal
  const data = useProposalApplication({ project });

  if (loading || (!project.id && loading)) {
    return <Loading />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <div className="w-full max-w-5xl mx-auto text-text-1/70">
        <div className="sm:flex justify-between items-center py-4">
          <PageTitle title="Community - Proposal Review & Approval" />
          <PDFComponent
            title={project.name + ", Community Proposal Review"}
            data={data}
          />
        </div>
        {project.id && (
          <>
            <div
              className="mx-auto max-w-5xl w-full bg-content shadow-md px-5 py-6 flex flex-col gap-0.5 "
              ref={pdfRef}
            >
              <ProposalComp project={project} />
            </div>

            {/* Action Buttons  */}

            <div className="max-w-5xl w-full mx-auto">
              <div className="flex justify-between items-center pt-4 pb-10">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    // dispatch(unsetSelectedProject());
                    navigate("/requests/community-approvals");
                  }}
                  className="cancel-rss-btn"
                  // disabled={problemStatLoad}
                >
                  Back
                </button>
                <div className="flex gap-2">
                  <button
                    type="button"
                    onClick={openAddCommunityPlanningTotalReject}
                    className="delete-rss-btn"
                    disabled={!isAuthorized("community_council", "update")}
                  >
                    Disapprove
                  </button>
                  <button
                    type="button"
                    onClick={openAddCommunityPlanningReject}
                    className="add-rss-btn"
                    disabled={!isAuthorized("community_council", "update")}
                  >
                    Hold
                  </button>
                  <button
                    type="button"
                    onClick={openAddCommunityPlanningApprove}
                    className="add-rss-btn"
                    disabled={!isAuthorized("community_council", "update")}
                  >
                    Approve
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </MainContainer>
  );
};

export default CommunityProposalReview;
